import Link from "next/link"
import currencyFormatter from "utilities/currencyFormatter"

export default function CaseWin({ category, title, slug, practice_area, amount }) {
  return (
    <article className="p-7 bg-white flex flex-col h-full max-h-fit justify-center gap-4 border-0.5 border-grey-cool">
      <h2 className="text-center">
        {category?.name ? (
          <span className="block text-base font-primary font-medium text-primary mb-3 capitalize">
            {category?.name}
          </span>
        ) : null}
        {amount ? (
          <span className="text-primary text-m3 lg:text-l1">{currencyFormatter(amount)}</span>
        ) : (
          <span className="text-primary text-m3 lg:text-l1">{title}</span>
        )}
      </h2>
      {practice_area?.name ? <h4 className="text-center text-primary">{practice_area.name}</h4> : null}
      <Link
        href={slug}
        target="_self"
        className="underline decoration-secondary hover:decoration-tertiary decoration-2 underline-offset-8 relative mx-auto table"
      >
        Read Story
      </Link>
    </article>
  )
}
